export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.481fc945.svg";